import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Button } from '@mui/material';

const videos = [
  { title: 'Getting Started: Connect Your Accounts', ytId: 'A6yCjYV7jtE' },
  { title: 'Create Custom Prompts (with AI help)', ytId: '0OCgPAGd03Y' },
  { title: 'Prompt Tester: Simulate Real Responses', ytId: 'QVexBD968zU' }
];

const HelpCenter: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%)' }}>
      {/* Header Spacer for fixed app bar in Layout (reduced) */}
      <Box sx={{ height: 32 }} />

      <Container maxWidth="xl" disableGutters sx={{ pt: 2, pb: 4, px: { xs: 2, md: 3 } }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, background: 'linear-gradient(90deg,#0ea5e9,#22c55e)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          Help Center
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Short, practical videos to help you set up and get the most out of Social In One.
        </Typography>

        <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
          {videos.map((v) => (
            <Box key={v.ytId}>
              <Card elevation={3} sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.06)' }}>
                <Box sx={{ position: 'relative', pt: '56.25%', backgroundColor: '#000' }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${v.ytId}`}
                    title={v.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
                  />
                </Box>
                <CardContent sx={{ p: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{v.title}</Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>

        {/* Contact Callout */}
        <Box
          sx={{
            mt: 5,
            p: 3,
            borderRadius: 3,
            textAlign: 'center',
            border: '1px solid rgba(0,0,0,0.06)',
            background: 'linear-gradient(135deg, rgba(14,165,233,0.06), rgba(34,197,94,0.06))'
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Still need help?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            If the videos didn't solve your issue, don't hesitate to contact us.
          </Typography>
          <Button
            component="a"
            href="mailto:info@socialinone.ai"
            variant="contained"
            sx={{
              textTransform: 'none',
              px: 2.5,
              py: 1,
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(90deg, #0ea5e9, #22c55e)',
              boxShadow: '0 8px 20px rgba(34,197,94,0.25)',
              '&:hover': {
                background: 'linear-gradient(90deg, #0284c7, #16a34a)'
              }
            }}
          >
            info@socialinone.ai
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HelpCenter;


